import {
  DialogDescription,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogClose,
  Typography,
  Checkbox,
  Button,
  Dialog,
  Label,
} from '@ui/components';
import { useTranslation } from 'react-i18next';
import { useState, FC } from 'react';

interface CurrentUserTransferSubmitDialogProps {
  onSubmit: () => void;
  isLoading?: boolean;
  disabled?: boolean;
  email: string;
  name: string;
  open?: boolean;
  onOpenChange?: (value: boolean) => void;
}

export const CurrentUserTransferSubmitDialog: FC<CurrentUserTransferSubmitDialogProps> = ({
  isLoading = false,
  open = false,
  onOpenChange = () => {},
  onSubmit,
}) => {
  const { t } = useTranslation();
  const [agreed, setAgreed] = useState<boolean>();

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent>
        <DialogHeader className="p-4">
          <DialogTitle>
            <Typography variant="h300">
              {t('CURRENT_USER_EDIT.ACCOUNT_OWNER_SUBMIT_DIALOG_HEADER')}
            </Typography>
          </DialogTitle>
        </DialogHeader>
        <DialogDescription>
          {t('CURRENT_USER_EDIT.ACCOUNT_OWNER_SUBMIT_DIALOG_DESCRIPTION')}
        </DialogDescription>
        <div className="px-4 pb-4 pt-2 flex items-center gap-2">
          <Checkbox
            onCheckedChange={(value) => setAgreed(!!value)}
            id="transferAgree"
            checked={agreed}
          />

          <Label htmlFor="transferAgree">
            <Typography variant="labelMediumMedium">
              {t('CURRENT_USER_EDIT.ACCOUNT_OWNER_SUBMIT_DIALOG_AGREE_LABEL')}
            </Typography>
          </Label>
        </div>
        <DialogFooter className="flex items-center justify-between">
          <DialogClose asChild>
            <Button variant="tertiary" className="flex-1" type="button" size="large">
              {t('CURRENT_USER_EDIT.ACCOUNT_OWNER_SUBMIT_DIALOG_CANCEL')}
            </Button>
          </DialogClose>
          <Button
            isLoading={isLoading}
            className="flex-1"
            disabled={!agreed}
            onClick={onSubmit}
            size="large"
          >
            {t('CURRENT_USER_EDIT.ACCOUNT_OWNER_SUBMIT_DIALOG_SUBMIT')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
